require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./service-devops-project-management-devops.json") })
        }
      }, "path---service-devops-project-management-devops");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---service-devops-project-management-devops!./.cache/json/service-devops-project-management-devops.json
// module id = 906
// module chunks = 231608221292675